import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import LivestockList from "../components/LivestockList";

const LivestockPage = () => {
  return (
    <>
      <Breadcrumb title="Livestock" />
      <LivestockList />
    </>
  );
};

export default LivestockPage;